module.exports = __webpack_public_path__ + "static/colors-utility-dont-29464871ca0ef0b0ac2f42b1345e498a.png";